/**
 * Fixes for gaps in WordPress core's mobile nav overlay interactivity.
 */

/**
 * "Products" (and any other has-child item) in the mobile nav overlay is a
 * dummy link with no real destination — tapping its label anywhere should
 * expand the submenu, not just the small chevron button next to it.
 * Forward the click to WordPress core's own toggle button so its
 * Interactivity API state stays the source of truth.
 */
const initSubmenuLabelClick = () => {
	const labels = document.querySelectorAll(
		'.wp-block-navigation__overlay-container .has-child > .wp-block-navigation-item__content'
	);

	labels.forEach(label => {
		const toggle = label.parentElement.querySelector(
			':scope > .wp-block-navigation-submenu__toggle'
		);

		if (!toggle) return;

		label.addEventListener('click', event => {
			event.preventDefault();
			toggle.click();
		});
	});
};

/**
 * The hamburger button's own click action only opens the overlay — it is
 * not a toggle. The CSS in _navigation.scss visually swaps its icon to an
 * X while the overlay is open (and hides the real close button, since
 * positioning it to sit exactly over the header's hamburger reliably is
 * its own can of worms). So while the overlay is open, a click on that
 * same button needs to be rerouted to the real close button instead of
 * being handled as another "open" — otherwise the X does nothing.
 *
 * A capture-phase listener on `document` guarantees this runs before
 * core's own click handler on the button, regardless of how/when the
 * Interactivity API attached its listener.
 */
const initHamburgerCloseOnReclick = () => {
	document.addEventListener(
		'click',
		event => {
			const openButton = event.target.closest(
				'.wp-block-navigation__responsive-container-open'
			);

			if (!openButton) return;

			const container = openButton
				.closest('.wp-block-navigation')
				?.querySelector('.wp-block-navigation__responsive-container');

			if (!container?.classList.contains('is-menu-open')) return;

			event.preventDefault();
			event.stopImmediatePropagation();

			container
				.querySelector('.wp-block-navigation__responsive-container-close')
				?.click();
		},
		true
	);
};

export const initNavOverlay = () => {
	initSubmenuLabelClick();
	initHamburgerCloseOnReclick();
};
